import React, { useEffect, useState } from 'react';

const today = () => new Date().toISOString().slice(0, 10);
const dateValue = (value) => {
  if (!value) return '';
  const date = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export default function QuickWorkFormModal({ open, quickWork, clients, users, categories = [], role, currentUserId, onClose, onSave }) {
  const staffMode = String(role || '').toLowerCase() === 'staff';
  const [form, setForm] = useState({ clientId: '', nature: '', remarks: '', assignedToId: '', dueDate: today(), status: 'Pending' });
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setForm(quickWork ? {
      clientId: quickWork.clientId || '',
      nature: quickWork.nature || '',
      remarks: quickWork.remarks || '',
      assignedToId: quickWork.assignedToId || '',
      dueDate: dateValue(quickWork.dueDate),
      status: quickWork.status || 'Pending',
    } : {
      clientId: '', nature: '', remarks: '', assignedToId: staffMode ? currentUserId : '', dueDate: today(), status: 'Pending',
    });
    setError('');
  }, [open, quickWork, staffMode, currentUserId]);

  if (!open) return null;
  const setValue = (key, value) => setForm((previous) => ({ ...previous, [key]: value }));
  const submit = (event) => {
    event.preventDefault();
    if (!form.clientId) return setError('Select a client.');
    if (!form.nature) return setError('Select nature of work.');
    if (!form.remarks.trim()) return setError('Enter a short remark.');
    setError('');
    onSave(form);
  };

  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-3">
    <form onSubmit={submit} className="w-full max-w-2xl rounded-lg bg-white shadow-xl">
      <div className="flex items-center justify-between border-b px-5 py-4"><div><h2 className="text-xl font-bold">{quickWork ? 'Edit Quick Work' : 'Add Quick Work'}</h2><p className="text-xs text-gray-500">Record small office work without creating a formal assignment.</p></div><button type="button" onClick={onClose} className="text-2xl">×</button></div>
      <div className="p-5">
        {error && <div className="mb-4 rounded bg-red-100 p-3 text-red-800">{error}</div>}
        <div className="grid gap-4 md:grid-cols-2">
          <label className="text-sm">Client<select disabled={staffMode && Boolean(quickWork)} className="mt-1 w-full rounded border px-3 py-2" value={form.clientId} onChange={(e) => setValue('clientId', e.target.value)}><option value="">Select</option>{clients.filter((item) => item.status !== 'Inactive').sort((a,b)=>String(a.name||'').localeCompare(String(b.name||''))).map((item)=><option key={item.id} value={item.id}>{item.name}</option>)}</select></label>
          <label className="text-sm">Nature of Work<select disabled={staffMode && Boolean(quickWork)} className="mt-1 w-full rounded border px-3 py-2" value={form.nature} onChange={(e) => setValue('nature', e.target.value)}><option value="">Select</option>{categories.map((item)=><option key={item} value={item}>{item}</option>)}</select></label>
          {!staffMode && <label className="text-sm">Assigned To<select className="mt-1 w-full rounded border px-3 py-2" value={form.assignedToId} onChange={(e) => setValue('assignedToId', e.target.value)}><option value="">Unassigned</option>{users.filter((item)=>item.isActive!==false&&String(item.status||'').toLowerCase()!=='inactive').map((item)=><option key={item.id} value={item.id}>{item.name||item.username||item.email}</option>)}</select></label>}
          <label className="text-sm">Due Date<input type="date" disabled={staffMode && Boolean(quickWork)} className="mt-1 w-full rounded border px-3 py-2" value={form.dueDate} onChange={(e)=>setValue('dueDate',e.target.value)}/></label>
          <label className="text-sm">Status<select className="mt-1 w-full rounded border px-3 py-2" value={form.status} onChange={(e)=>setValue('status',e.target.value)}><option>Pending</option><option>In Progress</option><option>Completed</option></select></label>
          <label className="text-sm md:col-span-2">Short Remark<textarea rows="3" className="mt-1 w-full rounded border px-3 py-2" value={form.remarks} onChange={(e)=>setValue('remarks',e.target.value)} /></label>
        </div>
        <div className="mt-6 flex justify-end gap-2"><button type="button" onClick={onClose} className="rounded border px-4 py-2">Cancel</button><button type="submit" className="rounded bg-blue-600 px-5 py-2 text-white">{quickWork ? 'Save Changes' : 'Add Quick Work'}</button></div>
      </div>
    </form>
  </div>;
}
